import ImageStoreDefault from '@/assets/img/store_img_default.png'
import { logHttpFailure, mainVueAxios } from '@/plugins/http'
import { adminRoleMixin } from '@/mixins/adminRoleMixin'
import { checkAuthActionAccess } from '@/utils/checkAuthActionAccess'
import { QR_WEB_URL } from '@/utils/constants'
import { convertImageToBase64 } from '@/utils/convertImageToBase64'
import { announceInitialAccount } from '@/utils/initialAccount'
import { initStoreTimes } from '@/utils/initStoreTimes'
import { STORE_FORM_TABS, storeDetailForm, storeFormTab, storeTimeErrorKeys } from '@/utils/storeDetailForm'
import { pgKeyBookAfterSave } from '@/utils/storePgKeys'
import {
  STORE_MNG_ACTION,
  STORE_ORIGIN,
  STORE_SAVE_TEXT,
  storeReadFailureNotice,
  storeSaveTarget,
} from '@/utils/storeSaveTarget'
import { mapGetters } from 'vuex'
import { util } from './utilMixin'

export const storeFormMixin = {
  // 「내부 관리자인가」는 `adminRoleMixin` 한 곳이 답한다 — 역할 **목록**을 보는 판정이라
  // `authId`(첫 역할)로 다시 물으면 겸직 계정에서 갈린다
  mixins: [adminRoleMixin],
  data() {
    return {
      deliveryAgencyOptions: [],
      brandCodeOptionsMap: {},
      defaultImageBase64: null,
      /** 상세 조회의 순번 — **마지막 요청의 응답만** 폼과 잠금을 만진다(빠르게 매장을 바꾸면 겹친다) */
      storeDetailSeq: 0,
    }
  },
  computed: {
    ...mapGetters({
      authId: 'auth/authId',
    }),
    /**
     * **`up()` 이 목록에서 고른 매장의 상세 다이얼로그를 여는가** — 다이얼로그를 그리는 화면이 소유한다(기본 거짓).
     *
     * 종전에는 `authId === 'custMng'` 이었다. 그런데 그 다이얼로그는 **화면**(매장 관리)의 것이고 역할의 것이
     * 아니다 — 같은 화면을 받은 관리점·운영사(R-E2, SQL 034)는 첫 역할이 달라 수정 버튼이 아무 일도 하지 않았다.
     * 그래서 다이얼로그가 있는 화면이 덮어쓰고 조건은 서버 액션으로 적는다(`StoreListView` — `utils/storeOps`).
     * 다이얼로그가 없는 화면(매장 정보 관리·사업장 트리)은 기본값 그대로다.
     */
    canOpenStoreDialog() {
      return false
    },
    /**
     * **이 화면이 관리자 매장 엔드포인트(`/store/mng`)를 쓰는가** — 화면이 소유하는 계약이고 기본은 거짓이다.
     *
     * 그 엔드포인트는 **본문의 `cust` 를 그대로** 소속 사업장으로 삼는다(`utils/storeSaveTarget` 머리말).
     * 그러니 쓸 수 있는 화면은 소속 사업장 칸을 그리는 폼 하나뿐이다 — 액션을 가진 겸직 계정이 그 칸이
     * 없는 화면에서 등록하면 사업장 없는 매장이 만들어진다. 액션 보유는 이 위에서 한 번 더 좁힌다.
     */
    usesMngStoreEndpoint() {
      return false
    },
    /**
     * **이 화면의 매장 폼 탭 이름** — `<el-tab-pane name>` 과 같은 목록이고 순서도 같다(첫 탭이 기본).
     * 매장 폼의 탭은 세 화면이 같은 컴포넌트(`StoreFormTabs`)로 그리므로 기본은 그 목록([STORE_FORM_TABS])이고,
     * 자기 탭을 그 뒤에 붙이는 화면이 덮어쓴다. 여러 화면의 합집합을 쓰면 없는 탭 이름이 통과해 빈 탭이 열린다.
     */
    storeFormTabs() {
      return STORE_FORM_TABS
    },
  },
  watch: {
    formError: {
      deep: true,
      handler: function (newVal, oldVal) {
        // 벨리데이션 메세지가 값은 있는데 Vue에서 표시 안해주는 현상 처리 하기 위함
        setTimeout(
          function () {
            var tmp = this.inputForm.storeNm
            this.inputForm.storeNm = this.inputForm.storeNm + ' '
            this.inputForm.storeNm = tmp

            var infoError = 0
            var custError = 0

            for (let val in newVal) {
              for (var j = 0, jlen = this.formError.custErrors.length; j < jlen; j++) {
                if (val.indexOf(this.formError.custErrors[j]) > -1) {
                  if ('' != newVal[val]) {
                    custError++
                  }
                }
              }

              for (var j = 0, jlen = this.formError.infoErrors.length; j < jlen; j++) {
                if (val.indexOf(this.formError.infoErrors[j]) > -1) {
                  if ('' != newVal[val]) {
                    infoError++
                  }
                }
              }
            }

            if (infoError > 0) {
              this.activiTabStore = 'info'
            } else if (custError > 0) {
              this.activiTabStore = 'cust'
            }
          }.bind(this),
          500
        )
      },
    },
  },
  created() {
    convertImageToBase64(ImageStoreDefault).then((result) => {
      this.defaultImageBase64 = result
    })
  },
  methods: {
    initStoreTimes,

    /**
     * 빈 매장 폼. **`statu` 는 부르는 자리가 소유한다** — 이 함수가 역할로 짐작하지 않는다.
     *
     * 종전에는 `authId === 'admin' || 'custMng'` 이면 `'I'`, 아니면 `'U'` 였다. 그 짐작은 `mng` 에게
     * 틀렸다(같은 화면의 admin 과 다른 답) — 사업장 트리의 「매장 등록」이 대상 없는 수정이 되어
     * 아무 데도 닿지 않았다. 폼이 등록인지 수정인지는 그 폼을 여는 자리가 이미 알고 있다.
     *
     * 역할이 남는 자리는 **그 역할이 이 칸을 채워 넣는가**뿐이다: 소속 사업장(`cust`)은 오더엔 내부
     * 관리자만 고르고([isInternalRole] — `StoreInfoFormPanel` 의 셀렉트와 같은 판정), 판매 채널·기본
     * 이미지는 매장 관리자 화면에 없다.
     *
     * @param {{statu: string}} options `'I'`(등록) · `'U'`(수정)
     */
    initInputForm: function (options) {
      const statu = (options || {}).statu

      // **화면이 빠뜨리면 여기서 드러난다** — `statu` 없이 만든 폼은 저장할 곳이 없어(`storeSaveTarget`)
      // 조용히 아무 일도 안 하는 버튼이 된다. 사용자 입력이 아니라 호출부의 오류다
      if ('I' !== statu && 'U' !== statu) {
        throw new Error("initInputForm: statu 는 'I'(등록) 또는 'U'(수정)여야 한다 — 화면이 넘긴다")
      }
      const isCustomer = this.authId === 'custMng'
      const isInternal = this.isInternalAdmin
      // 사업장 관리자 화면과 사업장 트리에만 있는 칸들 — 매장 관리자 화면은 이 칸을 그리지 않는다
      const hasChannelFields = isCustomer || isInternal

      const form = {
        statu,
        title: 'U' === statu ? this.$t('매장 수정') : '',
        storeCd: 0,
        storeNm: '',
        cust: isInternal ? { custCd: null, custNm: '' } : undefined,

        defaultLan: { id: '' },
        lans: [],
        detailYn: false,
        storeInfos: [
          { storeInfoNm: '', storeInfoAddr: '', storeInfoAddrDtl: '', storeInfoDesc: '', lanTp: { id: '', nm: '' } },
        ],
        storeTimes: [],
        storeTimesSimple: this.initStoreTimes(false),
        storeTimesDetail: this.initStoreTimes(true),
        storeTps: [],
        payTps: [],
        filterTps: [],
        deliveryCost: 0,
        webSalesTps: [],
        webSalesTypes: hasChannelFields ? [] : undefined,
        webSalesAlarms: hasChannelFields ? [] : undefined,
        kioskSalesTps: [],
        appSalesTypes: hasChannelFields ? [] : undefined,
        appSalesAlarms: hasChannelFields ? [] : undefined,
        useYn: 'Y',
        callgateTel: '',
        storeImg: '',
        storeImgFile: hasChannelFields ? this.defaultImageBase64 : '',
        busiNum: '',
        ceoNm: '',
        tel: '',
        fax: '',
        zipCd: '',
        addr: '',
        addrDtl: '',
        storeDesc: '',
        aiKioskInstructions: '',
        files: [],
        delFiles: [],
        startDt: hasChannelFields ? util.getNow('yyyy-MM-dd') : undefined,
        endDt: hasChannelFields ? null : undefined,
        orderNoti: false,
        notiTime: 0,
        printYn: false,
        ordertalkRequestEnabled: true,
        cutleryRequestEnabled: true,
        internationalPayYn: false,
        storeAddr: '',
        storeAddrDtl: '',
        gpsLng: 0.0,
        gpsLat: 0.0,
        accountNumber: '',
        bankTp: null,
        accountName: '',
        tp: 'week',
        weekTp: 'bw',
        weeks: [],
        sniffling: false,
        holidayDays: [],
        vactionDays: [],
        storeImg1: '',
        storeImgFile1: '',
        storeImg2: '',
        storeImgFile2: '',
        storeImg3: '',
        storeImgFile3: '',
        storeImg4: '',
        storeImgFile4: '',
        storeImg5: '',
        storeImgFile5: '',
        pickUpTime: 0,
        pgKind: '',
        mid: '',
        merchantKey: '',
        // PG사별 저장값 장부 — 새 매장은 저장한 PG사가 없다(`utils/storePgKeys`)
        pgKeyBook: {},
        cancelPw: hasChannelFields ? undefined : '',
        busiTp1: '',
        busiTp2: '',
        busiNm: '',
        busiEmail: '',
        alarmYn: true,
        orderReceiptCancelAlarmYn: true,
        orderReadyAlarmYn: true,
        deliveryCompleteAlarmYn: false,
        pointAddAlarmYn: true,
        pointUseAlarmYn: true,
        originInfo: '',
        hideInOrdertalk: false,
        // 주문 단말 꺼짐 시 준비중 표시(WP3) — 기본 OFF(영업중/영업종료 2상태). 폼 저장에 실리고 마지막 저장이 이긴다
        preparingStatusYn: false,
        menuShowTp: null,
        globalVatTp: null,
        globalServiceCostTp: null,
        vat: 0,
        serviceCost: 0,

        // 배달
        deliveryFees: [
          {
            minOrderAmount: 0,
            deliveryFee: 0,
          },
        ],

        // 배달 대행사
        deliveryAgencySettings: [],

        // 배달팁 설정
        deliveryTipSetting: {
          deliveryTipEnabled: false,
          deliveryTipType: 'distance',
          basicDeliveryDistance: '미사용',
          additionalDistanceUnit: '100m',
          additionalDistanceFee: 100,
          basicDeliveryFee: 4200,
          timeSlots: [
            {
              deliveryTip: 0,
              selectedDays: '',
              startTime: '00:00',
              endTime: '00:00',
              ord: 0,
            },
          ],
        },
      }

      return form
    },
    initFormError: function () {
      return {
        storeNm: '',
        storeAddr: '',
        storeAddrDtl: '',
        'defaultLan.id': '',
        storeTps: '',
        payTps: '',
        deliveryCost: '',
        webSalesTps: '',
        kioskSalesTps: '',
        useYn: '',
        storeImgFile: '',
        busiNum: '',
        ceoNm: '',
        tel: '',
        fax: '',
        zipCd: '',
        addr: '',
        addrDtl: '',
        storeDesc: '',
        aiKioskInstructions: '',
        originInfo: '',
        preparingStatusYn: '',
        infoErrors: [
          'storeNm',
          'storeAddr',
          'storeAddrDtl',
          'defaultLan.id',
          'storeTps',
          'payTps',
          'webSalesTps',
          'kioskSalesTps',
          'tel',
          'gpsLng',
          'gpsLat',
          'storeDesc',
          'aiKioskInstructions',
          'storeImgFile',
          'menuShowTp',
          'menuShowTp.cd',
        ],
        custErrors: [
          'useYn',
          'callgateTel',
          'busiNum',
          'ceoNm',
          'fax',
          'zipCd',
          'addr',
          'addrDtl',
          'accountNumber',
          'bankTp.cd',
          'accountName',
          'mid',
          'merchantKey',
          'cancelPw',
          'busiTp1',
          'busiTp2',
          'busiNm',
          'busiEmail',
        ],
        startDt: '',
        endDt: '',
        gpsLng: '',
        gpsLat: '',
        accountNumber: '',
        'bankTp.cd': '',
        accountName: '',
        pgKind: '',
        mid: '',
        merchantKey: '',
        cancelPw: '',
        busiTp1: '',
        busiTp2: '',
        busiNm: '',
        busiEmail: '',
        menuShowTp: '',
        globalVatTp: '',
        globalServiceCostTp: '',
        vat: '',
        serviceCost: '',
        'menuShowTp.cd': '',

        deliveryFees: [],
        deliveryAgencySettings: [],
        deliveryTipSetting: {},
        'deliveryTipSetting.deliveryTipType': '',
      }
    },

    // 정산은행구분 조회
    initBankTp: function () {
      mainVueAxios.search(
        '/code/getCode/BANK_TP',
        null,
        function (result) {
          this.bankTp = result
        }.bind(this)
      )
    },
    // 메뉴 표시 구분 조회
    initMenuShowTp: function () {
      mainVueAxios.search(
        '/code/getCode/MENU_SHOW_TP',
        null,
        function (result) {
          this.menuShowTp = result
        }.bind(this)
      )
    },
    // 부가세
    initGlobalVatTp: function () {
      mainVueAxios.search(
        '/code/getCode/GLOBAL_VAT_TP',
        null,
        function (result) {
          this.globalVatTp = result
        }.bind(this),
        false
      )
    },
    // 봉사료
    initGlobalServiceCostTp: function () {
      mainVueAxios.search(
        '/code/getCode/GLOBAL_SERVICE_COST_TP',
        null,
        function (result) {
          this.globalServiceCostTp = result
        }.bind(this),
        false
      )
    },
    initLan: function () {
      mainVueAxios.search(
        '/language',
        null,
        function (result) {
          this.lans = result
        }.bind(this)
      )
    },
    initPayTp: function () {
      mainVueAxios.search(
        '/code/getCode/WEB_PAY_TP',
        null,
        function (result) {
          this.payTp = result
        }.bind(this)
      )
    },

    // 첨부 파일 추가
    storeFileAdd: function (file, fileList) {
      util.imgToBase64(
        URL.createObjectURL(file.raw),
        file.raw.type,
        function (data) {
          this.inputForm.files.push({
            url: data,
            name: file.name,
            status: 'ready',
          })
        }.bind(this)
      )
    },
    // 수정 시 업로드 했던 이미지 삭제 시 삭제 리스트에 저장
    storeFileRemove: function (file, fileList) {
      var tmp = -1
      for (var i = 0, len = this.inputForm.files.length; i < len; i++) {
        if (this.inputForm.files[i].url == file.url) {
          tmp = i
        }
      }

      if (tmp > -1) {
        this.inputForm.files.splice(tmp, 1)
      }

      if (file.status == 'success') {
        file.status = 'del'
        this.inputForm.delFiles.push(file)
      }
    },
    fileNameChange: function (file) {
      if ('ready' != file.status) {
        file.status = 'change'
      }
    },

    // 매장 정보 QR
    getStoreInfoQr: function (storeId) {
      return QR_WEB_URL + '/' + storeId
    },
    // 매장 배달  QR
    getOutQr: function (storeId) {
      return QR_WEB_URL + '/' + storeId + '/1/D'
    },
    showQr: function (storeId) {
      if (null != document.getElementById('storeId_' + storeId)) {
        var tmp = document.getElementById('storeId_' + storeId)
        tmp.innerHTML = ''
        tmp.appendChild(new AraleQRCode({ text: QR_WEB_URL + '/' + storeId, size: 160 }))
      }

      if (null != document.getElementById('storeId_O_' + storeId)) {
        var tmp = document.getElementById('storeId_O_' + storeId)
        tmp.innerHTML = ''
        tmp.appendChild(new AraleQRCode({ text: QR_WEB_URL + '/' + storeId + '/1/D', size: 160 }))
      }
    },

    holidayChange: function (index) {
      if (this.inputForm.detailYn) {
        this.inputForm.storeTimesDetail[index].dayYn = false
        this.inputForm.storeTimesDetail[index].startTm = null
        this.inputForm.storeTimesDetail[index].endTm = null
        this.inputForm.storeTimesDetail[index].breakStartTm1 = null
        this.inputForm.storeTimesDetail[index].breakEndTm1 = null
        this.inputForm.storeTimesDetail[index].breakStartTm2 = null
        this.inputForm.storeTimesDetail[index].breakEndTm2 = null
        this.inputForm.storeTimesDetail[index].isBatch = false
      } else {
        this.inputForm.storeTimesSimple[index].dayYn = false
        this.inputForm.storeTimesSimple[index].startTm = null
        this.inputForm.storeTimesSimple[index].endTm = null
        this.inputForm.storeTimesSimple[index].breakStartTm1 = null
        this.inputForm.storeTimesSimple[index].breakEndTm1 = null
        this.inputForm.storeTimesSimple[index].breakStartTm2 = null
        this.inputForm.storeTimesSimple[index].breakEndTm2 = null
        this.inputForm.storeTimesSimple[index].isBatch = false
      }
    },

    addDeliveryFee: function () {
      this.inputForm.deliveryFees.push({
        minOrderAmount: 0,
        deliveryFee: 0,
      })
    },

    addDeliveryAgency: function (agency) {
      if (!this.inputForm.deliveryAgencySettings) {
        this.$set(this.inputForm, 'deliveryAgencySettings', [])
      }
      this.inputForm.deliveryAgencySettings.push(agency)
      // Vue.js에서 배열 변경 감지를 위해 강제로 반응성 트리거
      this.inputForm.deliveryAgencySettings = [...this.inputForm.deliveryAgencySettings]
    },
    removeDeliveryAgency: function (index) {
      this.inputForm.deliveryAgencySettings.splice(index, 1)
      // Vue.js에서 배열 변경 감지를 위해 강제로 반응성 트리거
      this.inputForm.deliveryAgencySettings = [...this.inputForm.deliveryAgencySettings]
    },
    removeDeliveryFee: function (index) {
      this.inputForm.deliveryFees.splice(index, 1)
    },

    // 배달 대행사 데이터 초기화
    initDeliveryAgencyData: function () {
      mainVueAxios.search(
        '/delivery/search',
        null,
        function (result) {
          // 배달 대행사 및 브랜드 코드 맵 초기화
          const deliveryAgencyOptions = []
          const brandCodeOptionsMap = {}

          // 데이터 그룹화
          const agencyGroups = {}

          // 배달 대행사 타입별로 데이터 그룹화
          if (result) {
            result.forEach((item) => {
              if (!agencyGroups[item.agencyType]) {
                agencyGroups[item.agencyType] = []

                // 배달 대행사 옵션 추가
                deliveryAgencyOptions.push({
                  value: item.agencyType,
                  label: item.agencyName,
                })

                // 브랜드 코드 옵션 맵 초기화
                brandCodeOptionsMap[item.agencyType] = []
              }

              // 브랜드 코드 옵션 추가
              brandCodeOptionsMap[item.agencyType].push({
                value: {
                  id: item.id,
                  agencyType: item.agencyType,
                  brandCode: item.brandCode,
                  brandName: item.brandName,
                },
                label: item.brandName + '(' + item.brandCode + ')',
              })
            })
          }

          this.deliveryAgencyOptions = deliveryAgencyOptions
          this.brandCodeOptionsMap = brandCodeOptionsMap
        }.bind(this),
        false
      )
    },

    save: function () {
      this.formError = this.initFormError()

      var isInvalid = false

      // 배달팁 설정 유효성 검사
      this.inputForm.deliveryFees.forEach((item, index) => {
        if (item.minOrderAmount < 0) {
          this.formError['deliveryFees.' + index + '.minOrderAmount'] = '최소 주문 금액은 0 이상이어야 합니다.'
          isInvalid = true
        }
        if (item.deliveryFee < 0) {
          this.formError['deliveryFees.' + index + '.deliveryFee'] = '배달팁은 0 이상이어야 합니다.'
          isInvalid = true
        }
      })

      // 배달팁 자동 모드 검증: 배달 대행사 설정이 없으면 자동 모드 불가
      if (this.inputForm.deliveryTipSetting && this.inputForm.deliveryTipSetting.deliveryTipEnabled) {
        if (this.inputForm.deliveryTipSetting.deliveryTipType === 'auto') {
          const hasDeliveryAgency =
            this.inputForm.deliveryAgencySettings &&
            this.inputForm.deliveryAgencySettings.length > 0 &&
            this.inputForm.deliveryAgencySettings.some((agency) => agency.deliveryAgency && agency.deliveryAgency.id)

          if (!hasDeliveryAgency) {
            this.formError['deliveryTipSetting.deliveryTipType'] =
              '배달팁 자동 모드를 사용하려면 배달 대행사 설정이 필요합니다.'
            isInvalid = true
          }
        }
      }

      if (isInvalid) {
        this.activiTabStore = 'delivery'
        return
      }

      if (this.inputForm.detailYn) {
        for (var i = 0, len = this.inputForm.storeTimesDetail.length; i < len; i++) {
          var tmp = this.inputForm.storeTimesDetail[i]

          if (!tmp.isHoliday) {
            if (!tmp.dayYn) {
              if (util.isEmpty(tmp.startTm) || util.isEmpty(tmp.endTm)) {
                this.formError['storeTimesDetail[' + i + '].tm'] = this.$t('영업 시간을 설정 하여 주십시오.')
                isInvalid = true
              }
            }

            if (
              (!util.isEmpty(tmp.breakStartTm1) && util.isEmpty(tmp.breakEndTm1)) ||
              (!util.isEmpty(tmp.breakEndTm1) && util.isEmpty(tmp.breakStartTm1)) ||
              (!util.isEmpty(tmp.breakStartTm2) && util.isEmpty(tmp.breakEndTm2)) ||
              (!util.isEmpty(tmp.breakEndTm2) && util.isEmpty(tmp.breakStartTm2))
            ) {
              this.formError['storeTimesDetail[' + i + '].btm'] = this.$t('BreakTime을 설정 하여 주십시오.')
              isInvalid = true
            }
          }
        }
      } else {
        for (var i = 0, len = this.inputForm.storeTimesSimple.length; i < len; i++) {
          var tmp = this.inputForm.storeTimesSimple[i]

          if (!tmp.isHoliday) {
            if (!tmp.dayYn) {
              if (util.isEmpty(tmp.startTm) || util.isEmpty(tmp.endTm)) {
                this.formError['storeTimesSimple[' + i + '].tm'] = this.$t('영업 시간을 설정 하여 주십시오.')
                isInvalid = true
              }
            }

            if (
              (!util.isEmpty(tmp.breakStartTm1) && util.isEmpty(tmp.breakEndTm1)) ||
              (!util.isEmpty(tmp.breakEndTm1) && util.isEmpty(tmp.breakStartTm1)) ||
              (!util.isEmpty(tmp.breakStartTm2) && util.isEmpty(tmp.breakEndTm2)) ||
              (!util.isEmpty(tmp.breakEndTm2) && util.isEmpty(tmp.breakStartTm2))
            ) {
              this.formError['storeTimesSimple[' + i + '].btm'] = this.$t('BreakTime을 설정 하여 주십시오.')
              isInvalid = true
            }
          }
        }
      }

      if (isInvalid) {
        this.activiTabStore = 'time'
        return
      }

      // **목적지는 역할 문자열이 아니라 액션 보유가 정한다** — 판정은 `utils/storeSaveTarget` 한 곳이다.
      // `mng` 은 `StoreAddForMng`·`StoreUpForMng` 를 갖고도 권한 없는 URL 로 나가 403(=세션 종료)이었다.
      //
      // **보낼 곳을 먼저 묻는다** — 아래 블록은 폼을 바꾼다(시간표 확정·`delFiles` 병합). 보내지 않을
      // 요청 때문에 폼이 먼저 바뀌면 화면이 저장하지 않은 모양으로 남는다.
      const target = storeSaveTarget({
        statu: this.inputForm.statu,
        storeCd: this.inputForm.storeCd,
        allowMng: this.usesMngStoreEndpoint,
        hasMngAdd: checkAuthActionAccess(STORE_MNG_ACTION.ADD),
        hasMngUp: checkAuthActionAccess(STORE_MNG_ACTION.UP),
        baseUrl: this.url,
      })

      // 보낼 곳이 없으면 **말한다** — 조용히 돌아가면 사람은 저장된 줄 안다. 폼이 아직 안 읽혔거나
      // 화면이 `statu` 를 잘못 넘긴 자리이므로 고칠 방법은 다시 부르는 것뿐이다
      if (!target) {
        this.$message.error(this.$t(STORE_SAVE_TEXT.noTarget))

        return
      }

      if (this.inputForm.detailYn) {
        this.inputForm.storeTimes = this.inputForm.storeTimesDetail
      } else {
        this.inputForm.storeTimes = this.inputForm.storeTimesSimple
      }

      for (var i = 0, len = this.inputForm.storeInfos.length; i < len; i++) {
        this.formError['storeInfos[' + i + '].storeInfoNm'] = ''
        this.formError['storeInfos[' + i + '].storeInfoAddr'] = ''
        this.formError['storeInfos[' + i + '].storeInfoAddrDtl'] = ''
        this.formError['storeInfos[' + i + '].storeInfoDesc'] = ''
      }

      this.inputForm.files = this.inputForm.files.concat(this.inputForm.delFiles)

      // **보내는 동안 잠근다** — 등록은 성공해도 폼이 그대로라 한 번 더 누르면 매장과 매장 관리자 계정이
      // 하나 더 생긴다. `btn` 은 사업장 트리에서 사업장 폼과 공유하는 객체이므로 **어느 갈래로 끝나든**
      // 풀어야 한다(실패에서 빠뜨리면 두 폼이 함께 굳는다)
      const unlock = function () {
        this.setSaveLocked(false)
      }.bind(this)

      this.setSaveLocked(true)

      // 보낸 그대로의 PG 칸과 그 폼 — 응답을 기다리는 동안 입력이 이어지거나 폼이 다른 매장으로 바뀌어도, 장부에는 보낸 값을 보낸 폼에 적는다
      const sentForm = this.inputForm
      const sentPg = { pgKind: sentForm.pgKind, mid: sentForm.mid, merchantKey: sentForm.merchantKey }

      const request = mainVueAxios[target.method](
        target.url,
        this.inputForm,
        this.formError,
        function (result) {
          // 새 매장 계정의 처음 비밀번호는 **이 응답에 한 번뿐**이다(결정 47 ③) — 화면 갱신이 실패해도 잃지 않게 먼저 보인다
          announceInitialAccount(this.$alert.bind(this), result)
          // 저장한 PG사의 값이 그 PG사의 저장값이다 — 폼을 다시 읽지 않는 화면(매장 정보 관리)도 PG사를 바꿀 때 이 값을 채운다
          sentForm.pgKeyBook = pgKeyBookAfterSave(sentForm.pgKeyBook, sentPg)
          // **저장은 됐다** — 그 뒤 화면 갱신이 실패해도 그렇게 말한다. 이 호출을 약속 안에 두면
          // 예외가 아래 `catch` 로 흘러 「성공」 토스트만 남고 사람은 갱신 실패를 모른다
          try {
            this.onStoreSaved({ method: target.method })
          } catch (error) {
            console.error('after save failed: ', error)
            this.$message.error(this.$t(STORE_SAVE_TEXT.afterSaveFailed))
          }
        }.bind(this)
      )

      // 실패에는 콜백이 없다 — 헬퍼가 요청 실패를 값(`ok:false`)으로 끝내며 필드 오류를 폼에 머지한다(`legacyHelpers`).
      // 사용자에게 할 말은 인터셉터가 이미 토스트로 했다. 어느 갈래로 끝나든 잠금을 풀고 **체인을 여기서 끝낸다**:
      // 거절은 이제 요청 실패가 아닌 오류뿐이지만, 받는 사람 없는 거절을 남기면 그것대로 잡히지 않는 오류가 된다
      request.finally(unlock).catch(function (error) {
        // 요약 한 곳을 지난다 — 요청 실패였다면 원본은 저장 본문(PG 상점키 등)과 CSRF 헤더를 싣는다(리뷰 N1)
        logHttpFailure(error, 'store save failed: ')
      })
    },
    /**
     * **저장 성공 뒤 — 화면이 소유한다.** 이 믹스인은 목적지 판정([storeSaveTarget])과 요청까지만 한다.
     *
     * 종전에는 `save()` 안에 성공 처리 세 갈래가 인라인으로 있었고 그 갈래를 역할 문자열로 골랐다
     * (`target.mng` · `authId === 'custMng'` · `'storeMng'`). 그런데 **역할과 화면은 일대일이 아니다** —
     * `storeMng` 이 첫 역할이면서 `StoreUpForMng` 를 겸직으로 가진 계정이 `StoreInfoView` 에서 저장하면
     * 관리자 갈래로 빠져 그 화면에 없는 `search()` 를 불러 `TypeError` 가 났고, 알림 설정 반영도 사라졌다.
     * 화면이 셋뿐이고(사업장 트리 = admin·mng · 매장 관리 = custMng · 매장 정보 관리 = storeMng,
     * `sys_menu` 기준) 각자 할 일이 다르므로, 할 일은 화면이 적는다.
     *
     * 기본은 아무 일도 하지 않는다 — 소비처 셋이 모두 같은 이름으로 덮어쓴다.
     *
     * @param {{method: string}} saved `method` 는 `'add'`·`'up'` — 화면이 문구와 다음 동작을 고를 때 쓴다
     */
    onStoreSaved: function (saved) {},
    /**
     * 매장 상세 조회. `initialTab` 은 custMng 다이얼로그가 열릴 때 처음 보일 탭(기본 `'info'`) — 조회가 성공해
     * 다이얼로그를 여는 그 자리에서 정하므로, 조회가 실패하면 탭 전환도 남지 않는다.
     */
    /**
     * 매장 상세 조회. `initialTab` 은 다이얼로그가 열릴 때 처음 보일 탭이다 — **그 화면의 탭 목록**
     * ([storeFormTabs])으로 거르고 모르는 값은 첫 탭이 된다. 「수정」 버튼이 `@click="up"` 이라
     * Element 가 MouseEvent 를 그 자리에 넘기기 때문이다.
     *
     * `origin` 은 그 매장을 누가 정했는가([STORE_ORIGIN]) — 기본은 목록에서 고른 매장이다. 주소가 정한 매장으로 들어온
     * 화면(`?storeCd=`)은 [STORE_ORIGIN.ROUTED] 를 넘긴다. 못 읽었을 때의 안내가 그것으로 갈린다.
     */
    up: function (initialTab, origin) {
      const tab = storeFormTab(initialTab, this.storeFormTabs)

      // 목록에서 고른 매장 — `GET /store/{cd}` 를 읽어 다이얼로그로 연다([canOpenStoreDialog])
      if (this.canOpenStoreDialog) {
        return this.loadStoreDetail({
          url: this.url + '/' + this.selectData.storeCd,
          title: this.$t('매장 수정'),
          origin,
          onLoaded: function () {
            this.activiTabStore = tab
            this.dialogFormVisible = true
          }.bind(this),
        })
      }

      // 자기 매장 하나(매장 정보 관리) — 화면의 `url` 이 곧 그 매장이다
      if (this.authId !== 'storeMng') return

      return this.loadStoreDetail({ url: this.url, title: this.$t('매장 수정'), origin })
    },
    /**
     * **매장 상세를 읽어 폼에 채운다 — 한 곳.** 잠금·조회·해제·실패 안내·순번 가드를 함께 갖는다.
     *
     * 세 화면이 같은 규칙을 쓴다: **읽는 동안은 저장할 수 없고**(그러지 않으면 앞 폼이 남은 채 저장돼
     * 매장이 하나 더 생긴다) 읽기에 성공해야 풀린다. 실패하면 잠긴 채로 남으므로 그 이유를 말한다.
     *
     * 응답은 **최신 요청의 것만** 받는다([storeDetailSeq]). 매장을 빠르게 바꾸면 늦게 온 옛 응답이
     * 새 폼을 덮거나, 이미 잠긴 새 조회를 풀어 버린다.
     *
     * 오류 토스트는 **끈다**(`showErrorMessage: false`) — 인터셉터의 문구와 화면의 문구가 함께 뜨면
     * 같은 실패를 두 번 말한다. 이 호출부는 대체 동작(잠금 유지 + 안내)을 갖는다.
     *
     * 실패 안내는 [storeReadFailureNotice] 가 고른다 — 그 매장을 누가 정했는가(`origin`, 없으면 목록에서 고름)와 왜 못
     * 읽었나(확실한 거절 / 그 밖의 실패)에 따라 할 말이 다르다(R-K2 J4 · 리뷰 L2·N2).
     *
     * @param {{url: string, title: ?string, onLoaded: ?function, origin: ?string}} options
     */
    loadStoreDetail: function (options) {
      const config = options || {}
      const seq = this.storeDetailSeq + 1

      this.storeDetailSeq = seq
      this.setSaveLocked(true)

      const isLatest = function () {
        return this.storeDetailSeq === seq
      }.bind(this)

      /** 못 읽었다 — 요청 실패(헬퍼의 값)와 그 밖의 거절이 이 한 자리로 온다. 토스트를 끈 조회라 여기가 유일한 안내다 */
      const failed = function (error) {
        if (!isLatest()) return

        logHttpFailure(error, 'store detail load failed: ')
        const notice = storeReadFailureNotice(config.origin || STORE_ORIGIN.PICKED, error)
        this.$message({ type: notice.type, message: this.$t(notice.message) })
      }.bind(this)

      return mainVueAxios
        .get(
          config.url,
          function (result) {
            if (!isLatest()) return

            this.formError = storeTimeErrorKeys().reduce(
              (errors, key) => Object.assign(errors, { [key]: '' }),
              this.initFormError()
            )
            this.inputForm = storeDetailForm(result, { title: config.title })
            this.setSaveLocked(false)

            // **읽기는 됐다** — `onLoaded` 가 던져도 조회 실패(「읽지 못했다」)로 둔갑시키지 않는다.
            // 잡는 것은 이 동기 훅이 던진 것뿐이고, 그 뒤 Vue 렌더에서 나는 예외는 여기 닿지 않는다
            try {
              if (config.onLoaded) config.onLoaded(this.inputForm)
            } catch (error) {
              console.error('after load failed: ', error)
              this.$message.error(this.$t(STORE_SAVE_TEXT.afterLoadFailed))
            }
          }.bind(this),
          { showErrorMessage: false }
        )
        .then(function (outcome) {
          if (!outcome.ok) failed(outcome.error)
        })
        .catch(failed)
    },
    /**
     * **진행 중인 상세 조회를 버린다** — 늦게 온 응답이 지금 폼을 덮지 못하게 한다.
     *
     * 등록 폼을 여는 자리가 부른다. 그러지 않으면 상세를 읽는 동안 「등록」을 누를 때 늦은 응답이
     * 빈 등록 폼을 **수정 폼으로 덮고**, 이어 저장하면 엉뚱한 기존 매장이 고쳐진다. 늦은 콜백에
     * `statu === 'I'` 가드를 덧대지 않는 이유: 순번 축의 주인이 이미 여기이고, 가드를 더하면 같은
     * 질문에 답하는 자리가 둘이 된다.
     */
    cancelStoreDetail: function () {
      this.storeDetailSeq += 1
    },
    /**
     * **저장 버튼을 잠그고 푸는 자리** — 기본은 이 화면이 가진 `btn` 을 바꾼다.
     *
     * 사업장 트리의 폼은 `btn` 을 **부모에게 받으므로** 직접 바꾸지 않고 이 메서드를 덮어 이벤트로 알린다
     * (`vue/no-mutating-props`). 잠금의 규칙은 믹스인이, 적용 방법은 화면이 갖는다.
     */
    setSaveLocked: function (locked) {
      this.btn.saveDisabled = locked
    },
  },
}
